import axios from 'axios';
import { useCallback, useState } from 'react';
import { BASE_URL, LOCAL_AUTH_JWT } from '../utils/constants';

const useV3Axios = () => {
    const [state, setState] = useState({ loading: false, error: null, data: null });

    const sendRequest = useCallback(async (url, body = {}, method = 'post') => {
        setState({ loading: true, error: null, data: null });

        const token = localStorage.getItem(LOCAL_AUTH_JWT);
        const config = {
            validateStatus: () => true,
            headers: token ? { Authorization: `Bearer ${token}` } : {},
        };

        try {
            let res;
            switch (method) {
                case 'get':
                    res = await axios.get(BASE_URL + url, { ...config, params: body });
                    break;
                case 'put':
                    res = await axios.put(BASE_URL + url, body, config);
                    break;
                case 'delete':
                    res = await axios.delete(BASE_URL + url, config);
                    break;
                default:
                    res = await axios.post(BASE_URL + url, body, config);
            }

            if (res.status >= 200 && res.status < 300) {
                setState({ loading: false, error: null, data: res.data });
            } else if (res.status === 400 || res.status === 403 || res.status === 429) {
                // 400: validation / business logic errors — backend message is meaningful
                // 403: permission errors — backend message explains what action is forbidden
                // 429: rate limit errors — backend message includes wait time
                const message = res.data?.message
                    ? Array.isArray(res.data.message) ? res.data.message[0] : res.data.message
                    : 'Something went wrong. Please try again.';
                setState({ loading: false, error: message, data: null });
            } else {
                setState({ loading: false, error: 'Something went wrong. Please try again.', data: null });
            }
        } catch (err) {
            setState({ loading: false, error: 'Something went wrong. Please try again.', data: null });
        }
    }, []);

    return {
        isLoading: state.loading,
        error: state.error,
        data: state.data,
        sendRequest,
    };
};

export default useV3Axios;
